<div class='container-float'>

  <b-row class="mb-3">
    <b-col cols="12">
      &nbsp;
    </b-col>
  </b-row>

  <b-alert v-model="showAlert" variant="warning" dismissible>
    {{ alertMsg }}
  </b-alert>

  <b-modal v-model="showModal" ref="delete" id="delete" title="Conferma cancellazioe" @ok="handleDelete" @cancel="handleCancel">
    <h3>Sei sicuro di voler cancellare la riga?</h3>
  </b-modal>

  <b-row class="mb-3">
    <b-col cols="12">

      <b-card
        title="Luoghi"
      >
        <b-card-body style="text-align: left;">
          <b-row>
            <b-col cols="6">
              <span class='label'>
                Luogo
              </span>
            </b-col>
            <b-col cols="4">
              <span class='label'>
                Nazione
              </span>
            </b-col>
            <b-col cols="2">
              <span class='label'>
                Acronimo
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-input v-model="form_data.location" class=""></b-form-input>
            </b-col>
            <b-col cols="4">
              <b-form-select v-model="form_data.nation_id" :options="nations_list"></b-form-select>
            </b-col>
            <b-col cols="2">
              <b-form-input v-model="form_data.acronym" class=""></b-form-input>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              &nbsp;
            </b-col>          
          </b-row>

          <b-row>
            <b-col cols="2">
              <b-button variant="warning" @click="cancelLocation">Annulla</b-button>
            </b-col>          
            <b-col cols="7">
              &nbsp;
            </b-col>          
            <b-col cols="2">
              <b-button v-if="!current_id" variant="primary" @click="insertLocation">Inserisci</b-button>
              <b-button v-if="current_id" variant="success" @click="updateLocation">Aggiorna</b-button>
            </b-col>          
            <b-col cols="1">
              &nbsp;
            </b-col>          
          </b-row>
        </b-card-body>
      </b-card>

      <b-card
        title="Lista Nazioni"
      >
        <b-card-body style="text-align: left;">
          <b-row>
            <b-col cols="12">

              <table class="" :key="locations.length">
                <thead>
                  <tr>
                    <th style="width: 0%;"></th>
                    <th style="width: 50%;">Luogo</th>
                    <th style="width: 45%;">Nazione</th>
                    <th style="width: 10%;">Acronimo</th>
                    <th style="width: 5%;"></th>
                  </tr>
                </thead>
                <tbody>                  
                  <tr v-for="location in locations" :key="location.id" class="row-selection">
                    <td @click="editRow(location)" class="link" style="visibility: hidden;">{{ location.id }}</td>
                    <td @click="editRow(location)" class="link">{{ location.place }}</td>
                    <td @click="editRow(location)" class="link">{{ location.nation }}</td>
                    <td @click="editRow(location)" class="link">{{ location.acronym }}</td>
                    <td>
                      <i
                        class="fas fa-trash"
                        @click="deleteRecord(location.id)"
                        style="pointer: cursor !important;"
                      ></i>
                    </td>
                  </tr>                
                </tbody>
              </table>

            </b-col>
            <b-col cols="10">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  aria-controls="my-table"
                  @change="onPageChange"
                  class="my-3"
                ></b-pagination>
            </b-col>
            <b-col cols="2" style="margin-top: 1.5rem;">
                <b-form-select v-model="perPage" :options="[5, 10, 15, 20]" class="mb-3" style="width: 6rem;" @change="onPerPageChange"></b-form-select>
            </b-col>            
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>

</div>